import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import React, { Component } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class QueriesQueue extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            queries: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            
            resolutionDate: new Date(),
            enteredDate: null,
            selectedCityscope: null,
            cityscopeOptions: [],
            cityscope: null,
            excludePerpetual: true,

            selectedQueryType: null,
            queryTypeOptions: [],
            quertyType: null,

            selectedProperty: null,
            propertyOptions: [],
            propertykey: ""
            
        };

        
    }
    

    async componentDidMount() {
        console.log("In AgentList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        const queries = await this.getQueries({cityscope: this.state.cityscope
            , excludeperpetual: this.state.excludePerpetual ? this.state.excludePerpetual : null
            , entereddate: this.state.enteredDate!==null ? Moment(this.state.enteredDate).local().format(): null
            , resolutiondate: this.state.resolutionDate !== null? Moment(this.state.resolutionDate).local().format(): null
            , propertykey: this.state.propertykey
            });
        this.setState({ queries });
        
        await this.getCityscopes();

        await this.getQueryTypes();

        document.title = "Queries Queue";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ queries: [] });        
    }

    async getQueries(filter) {
        console.log("Inside getqueries() ");
        
        return API.get("colin", "/queues/queries", { 'queryStringParameters': filter, 'cancelToken': source.token });
      
    }

    
    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    

    getQueryTypes() {
        try {
            API.get("colin", "/querytypes", { 'cancelToken': source.token }).then((queryTypeOptions) => {
                if (queryTypeOptions) {
                    this.setState(state => ({ queryTypeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting query types");
        }
    }

    handleCityscopeChange = async (selectedCityscope) => {
        
        this.setState({ selectedCityscope
                        ,cityscope: selectedCityscope.value 
                        , modified: true })        
    }

 
    handleQueryTypeChange = async (selectedQueryType) => {
        
        this.setState({ selectedQueryType
                        ,queryType: selectedQueryType.value 
                        , modified: true })        
    }


    handleSubmit = async event =>{
        event.preventDefault();
        try {
            this.setState({isLoading: true});
            const queries = await this.getQueries({cityscope: this.state.cityscope
                                                    , querytype: this.state.queryType
                                                    , excludeperpetual: this.state.excludePerpetual ? "True" : null
                                                    , entereddate: this.state.enteredDate!==null ? Moment(this.state.enteredDate).local().format(): null
                                                    , resolutiondate: this.state.resolutionDate !== null? Moment(this.state.resolutionDate).local().format(): null
                                                    , propertykey: this.state.propertykey
                                                    });
            this.setState({ queries });
            this.setState({isLoading: false});
        } catch (e) {
            alert(e);
        }
    }
    
    handleCheckBoxChange = event => {
        
        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur)
        


    }
    
      
    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
    renderTable(data) {
        const columns = [

            {
                id: 'query_id',
                Header: 'Query ID',
                maxWidth: 80,
                accessor: 'query_id' ,
                Cell: e => <a target="_blank" rel="noopener noreferrer" href={`/properties/${e.original.property_key}/queries/${e.value}`} >{e.value}</a>
        }
        , {
                id: 'query_type',
                Header: 'Query Type',            
                accessor: 'query_type',
                maxWidth: 100
                

            }, 
            {
                id: 'created_date',
                Header: 'Date Created',
                maxWidth: 100,
                style: { textAlign: "center" },
                accessor: d => {
                    if (d.created_date) {
                        return Moment(d.created_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }
            },
                {
                    id: 'date_to_resolve',
                    Header: 'Date To Resolve',
                    maxWidth: 100,
                    style: { textAlign: "center" },
                    accessor: d => {
                        if (d.date_to_resolve) {
                            return Moment(d.date_to_resolve)
                                .local()
                                .format("DD-MM-YYYY")
                        }
                        else { return null }
                    }

            },{
                id: 'perpetual',
                Header: 'Perpetual',            
                accessor: 'perpetual',
                maxWidth: 80,
                Cell: e=> e.value.toString()

            }
            ,
            {
                id: 'doc_number',
                Header: 'Doc Number',            
                accessor: 'doc_number',
                maxWidth: 80

            }
            ,
            {
                id: 'problem',
                Header: 'Problem',            
                accessor: 'problem',
                style:{ 'white-space': 'unset'},
                Cell: e=> e.value+"\r\n\r\n\r\n\r\n"

            }
            ,
            {
                id: 'property_key',
                Header: 'Cityscope Reference',            
                accessor: 'property_key',
                maxWidth: 100
            },
            {
                id: 'street_address',
                Header: 'Street Address',            
                accessor: 'street_address',
                maxWidth: 200
            }
            ,
            {
                id: 'suburb',
                Header: 'Suburb',            
                accessor: 'suburb',
                maxWidth: 100
            }
            ,
            {
                id: 'title_details',
                Header: 'Title',            
                accessor: 'title_details',
                maxWidth: 200,
                style:{ 'white-space': 'unset'}
            }
            ,
            {
                id: 'area',
                Header: 'Area',            
                accessor: 'area',
                maxWidth: 70
            }
            ,
            {
                id: 'created_by',
                Header: 'Created By',            
                accessor: 'created_by',
                maxWidth: 100
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={100}
                    sortable={true}
                    className="-striped -highlight"                                            
                />
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

 
    handleEnteredDateChange = (date) =>{
        if (date) {
            this.setState({
                enteredDate: new Date(date)
                , modified: true });
        }
        else {
            this.setState({
                enteredDate: null
                , modified: true });
        }
        
    }

    handleResolutionDateChange = (date) =>{
        if (date) {
            this.setState({
                resolutionDate: new Date(date)
                , modified: true });
        }
        else {
            this.setState({
                resolutionDate: null
                , modified: true });
        }
        
    }
    
    renderComponent() {
        return (
            <div className="queries">
                <form onSubmit={this.handleSubmit}>
                 <Row >
                     <Col  sm={2} md={2} lg={1}>
                     <Form.Group controlId="state" >
                        <Form.Label className="text-right" >Cityscope</Form.Label>

                        <Select
                            value={this.state.selectedCityscope}
                            onChange={this.handleCityscopeChange}
                            options={this.state.cityscopeOptions}
                            onInputChange={this.handleInputChange}

                        />


                    </Form.Group>
                     </Col>
                 <Col sm={4} md={4} lg={1}>                    
                    <Form.Group  controlId="selectedQueryType" >
                        <Form.Label  >Query Type</Form.Label>
                        <Select
                            value={this.state.selectedQueryType}
                            onChange={this.handleQueryTypeChange}
                            options={this.state.queryTypeOptions}
                            onInputChange={this.handleInputChange}
                        />
                    </Form.Group>
                    </Col > 
                    
                    <Col sm={6} md={6} lg={1}> 
                    <Form.Group   controlId="enteredDate" >
                        <Form.Label>Queries Entered Since</Form.Label><br/>
                            <DatePicker
                                selected={this.state.enteredDate}
                                onChange={this.handleEnteredDateChange}
                                name="enteredDate"
                                onBlur={this.handleSave}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                isClearable={true}
                            />
                    </Form.Group>
                        </Col>                        
                    <Col sm={6} md={6} lg={1}> 
                    <Form.Group   controlId="resolutionDate" >
                        <Form.Label>Resolution Date Before</Form.Label><br/>
                            <DatePicker
                                selected={this.state.resolutionDate}
                                onChange={this.handleResolutionDateChange}
                                name="resolutionDate"
                                onBlur={this.handleSave}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                isClearable={true}
                            />
                    </Form.Group>
                        </Col>
                        <Col sm={4} md={4} lg={1}>                    
                    <Form.Group  controlId="propertykey" >
                        <Form.Label  >Cityscope Ref</Form.Label> 
                        
                        <Form.Control

                            onChange={this.handleChange}
                            value={this.state.propertykey}
                            as="input"
                            type="text"
                            placeholder="% Wild card"
                        />
                    </Form.Group>
                    </Col > 
                    <Col sm={4} md={4} lg={1}>                    
                    <Form.Group  controlId="excludePerpetual" >
                        {/* <Form.Label  >Exclude Perpetual</Form.Label> */}
                        
                        <Form.Check checked={this.state.excludePerpetual}
                                onChange={this.handleCheckBoxChange}
                                label="Exclude Perpetual"
                                type="checkbox"
                                name="excludePerpetual"
                                onBlur={this.handleBlur}
                            />
                    </Form.Group>
                    </Col > 
                        <Col>
                        <Button type="submit" variant="primary">Search</Button>
                        </Col>
                    </Row> 
                    </form>
                    <Row>
                <Col><b>{this.state.queries?this.state.queries.length: "0"} of {this.state.queries? this.state.queries.length>0 ? this.state.queries[0].result_count: "0":"0"} records returned.</b></Col>
            </Row>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.queries) : this.renderPacman() }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="AgentList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
